import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

const MobileSearchContainer = styled.div`
  height: 350px;
`;

const BackgroundImage = styled(Ui.Image)`
  padding-top: ${({ theme }) => theme.spacing['40']};
  height: 100%;
`;

const SearchFormContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing['40']};
  padding: ${({ theme }) => theme.spacing['50']};
  width: 100%;
`;

export { BackgroundImage, MobileSearchContainer, SearchFormContainer };
